<template>
  <wl-taste-profile
    :taste="tasteData"
  />
</template>

<script lang="ts">
  import {Options, Vue} from 'vue-property-decorator';
  import productStore from '../../../bps/stores/product/ProductStore';
  import WlTasteProfile from '../../../bps/components/wlTasteProfile/wlTasteProfile.vue';
  import type WineLuthierTaste from '../../../bps/types/WineLuthierTaste';

  @Options({
    name: 'product-taste',
    components: {
      WlTasteProfile
    }
  })
  export default class ProductTaste extends Vue {
    get tasteData(): WineLuthierTaste {
      return productStore.wineLuthierTaste;
    }
  }
</script>

